import { LanguageCode } from './Constants'
import { State } from './Geo'
import { SupportedContentBooster } from './Hazards'

export enum UserType {
    AUTHORITY = 'Authority',
    PUBLIC = 'Public',
}

export interface UserInfoDTO {
    first_name: string
    last_name: string
    email: string
    phone: string
    dob: Date
}

export interface UserAuthDTO extends UserInfoDTO {
    password: string
}

export enum Tutorial {
    NEW_MOBILE_MENU = 'NewMobileMenu',
    CSO_MOVED = 'CrisisSupportOptionsMoved',
    PREP_CHECKS_TUTORIAL = 'PrepChecksTutorial',
    LOCAL_CONTENT_INTRO = 'Local_Content_Intro',
    HIDE_LOCAL_CONTENT_CALLOUT = '@HideLocalContentCallout',
    DISABLE_AUTO_SHOW_NO_LOCO = '@DisableAutoShowNoLoCo',
    HAZADAPT_ID_REBRAND = 'HazAdaptIDRebrand',
}

export interface User extends UserInfoDTO {
    user_id: number
    gender: Gender | null
    biological_sex: BiologicalSex | null
    state: State | null
    county: string | null
    zip: string | null
    preferred_language: LanguageCode
    preferred_content_boosters: SupportedContentBooster[]
    tutorials_shown: string[]
    date_created?: Date
    date_updated?: Date
}

export type RPUserStatus =
    | 'active'
    | 'inactive'
    | 'paused'
    | 'invited'
    | 'deactivated'

export type RPOrganizationStatus = RPUserStatus

export interface RPUser extends Partial<User> {
    user_id: number
    first_name: string
    last_name: string
    email: string
    hazadapt_id_email?: string
    rp_user_id: number
    organization_id: number
    title: string | null
    profile_picture_uri: string | null
    status: RPUserStatus
    owner: boolean
    admin: boolean
    permissions: RPUserPermission[]
}

export interface NewRPUserDTO {
    first_name: string
    last_name: string
    email: string
    title?: string
    permissions: RPUserPermission[]
    status?: RPUserStatus
}

export interface RPUserDetailsDTO extends Omit<NewRPUserDTO, 'email'> {}

export enum RPUserPermission {
    // Top-level permissions; people with these roles have all permissions
    OWNER = 'owner',
    ADMIN = 'admin',

    // Organization management
    EDIT_ORGANIZATION = 'edit-organization',
    MANAGE_BILLING = 'manage-billing',

    // Member management
    ADD_MEMBER = 'add-member',
    EDIT_MEMBER = 'edit-member',
    DELETE_MEMBER = 'delete-member',
    PAUSE_MEMBER_ACCESS = 'pause-member-access',
}

export enum Gender {
    AGENDER = 'Agender',
    ANDROGYNOUS = 'Androgynous',
    BIGENDER = 'Bigender',
    CISGENDER_MAN = 'Cisgender Man',
    CISGENDER_WOMAN = 'Cisgender Woman',
    // FEMALE = 'Female',
    FEMALE_TO_MALE = 'Female to Male',
    GENDER_FLUID = 'Gender Fluid',
    GENDER_NONCONFORMING = 'Gender Nonconforming',
    GENDER_QUESTIONING = 'Gender Questioning',
    GENDER_VARIANT = 'Gender Variant',
    GENDERQUEER = 'Genderqueer',
    INTERSEX = 'Intersex',
    // MALE = 'Male',
    MALE_TO_FEMALE = 'Male to Female',
    MAN = 'Man',
    NEITHER = 'Neither',
    NEUTROIS = 'Neutrois',
    NON_BINARY = 'Non-Binary',
    OTHER = 'Other',
    PANGENDER = 'Pangender',
    TRANSFEMININE = 'Transfeminine',
    TRANSGENDER_MAN = 'Transgender Man',
    TRANSGENDER_PERSON = 'Transgender Person',
    TRANSGENDER_WOMAN = 'Transgender Woman',
    TRANSMASCULINE = 'Transmasculine',
    TRANSSEXUAL_MAN = 'Transsexual Man',
    TRANSSEXUAL_PERSON = 'Transsexual Person',
    TRANSSEXUAL_WOMAN = 'Transsexual Woman',
    TWO_SPIRIT = 'Two-Spirit',
    WOMAN = 'Woman',
}

export enum BiologicalSex {
    MALE = 'Male',
    FEMALE = 'Female',
    INTERSEX = 'Intersex',
    OTHER = 'Other',
}
